import VueI18n from "vue-i18n";

import { DayCondition } from "../DayCondition";
import { PeriodConditionsTypeEnum } from "../types";

export class DayOfWeek extends DayCondition {
  type: PeriodConditionsTypeEnum = PeriodConditionsTypeEnum.DayOfMonth;

  getBeautifiedValues(i18n: VueI18n): string {
      const weekDays = [
        i18n.t('pi_base_weekday_monday_key').toString(),
        i18n.t('pi_base_weekday_tuesday_key').toString(),
        i18n.t('pi_base_weekday_wednesday_key').toString(),
        i18n.t('pi_base_weekday_thursday_key').toString(),
        i18n.t('pi_base_weekday_friday_key').toString(),
        i18n.t('pi_base_weekday_saturday_key').toString(),
        i18n.t('pi_base_weekday_sunday_key').toString(),
      ]

      return this.values
        .slice()
        .sort()
        .reduce((string, currentValue, currentIndex) => {
          const commaIfNotLast = currentIndex === this.values.length - 1 ? '' : ', '

          string += `${ weekDays[+currentValue - 1] }` + commaIfNotLast

          return string
        }, '')
    }
}
